export class WorkflowProcessingErrorNotification {
	public folderId: string;
	public code: string;
	public error: string;

	public static fromJson(other: any): WorkflowProcessingErrorNotification {
		const instance = new WorkflowProcessingErrorNotification();
		instance.folderId = other.FolderId;
		instance.code = other.Code;
		instance.error = other.Error;
		return instance;
	}
}
